import React, { Component } from 'react'
import './App.css'
import Pages from './pages'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import 'sweetalert2/src/sweetalert2.scss'
import swal from 'sweetalert2'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

import { detect } from 'detect-browser'
const browser = detect()

class App extends Component {
  render() {
    return (
      <I18nextProvider i18n={i18n}>
        <div>
          <React.Suspense fallback={null}>
            <ErrorBoundary>
              <Switch>
                <Route exact path="/" component={Pages.Route404} />
                <Route path="/:slug" component={Pages.OperatorLanding} />
                <Redirect to="/" />
              </Switch>
            </ErrorBoundary>
          </React.Suspense>
        </div>
      </I18nextProvider>
    )
  }

  HandleIe() {
    swal.fire('Whoops!', 'This site is supported by current versions of Chrome, Firefox, Edge, and Safari.', 'info')
  }

  componentDidMount() {
    if (browser && browser.name === 'ie') {
      this.HandleIe()
    }
  }
}

export default withRouter(App)
